<template>
	<widget title="Revenue Codes" icon="fa-folder">

		<onboarding-card v-if="!isWizardInstance" title="Set up revenue codes" name="Revenue Codes" setting-key="revenueCodes">
			<p>Setting up revenue codes to reflect your accounting software can help you better track revenue. We have added some examples below.</p>
		</onboarding-card>

		<p>Revenue codes should align with your accounting software</p>

		<form v-on:submit.prevent="addRevenueCode">

			<div class="d-flex align-items-center">

				<label class="mr-2 mb-0 font-weight-bold">Add Code</label>

				<field :params="{placeholder:'Code'}" v-model="code"></field>

				<field :params="{placeholder:'Code Description'}" v-model="codeDescription"></field>

				<button 
					type="submit" 
					class="btn btn-success">
					<i class="fa fa-save"></i>
					Add
				</button>
		
			</div>

		</form>

		<table-list
			:records="localCodes"
			:fields="codeFields"
			record-name="Revenue Code"
			:hide-record-count="true"
			:has-delete="true"
			:sortable="true"
			delete-endpoint="/RevenueCode/delete"
			v-on:modelChange="modelChange">
		</table-list>

	</widget>
</template>
<script type="text/javascript">

import Widget from "@/components/Widget"
import TableList from "@/components/TableList"
import Field from "@/components/Field"

import OnboardingCard from "@/components/OnboardingCard"

export default {
	name: "RevenueCodeManagerWidget",
	components: {
		Widget,
		TableList,
		Field,
		OnboardingCard
	},
	props: ["revenueCodes","isWizardInstance"],
	data() {
		return {
			code: "",
			codeDescription: "",
			localCodes: [],
			codeFields: [
				{label: "Code",key:"code"},
				{label: "Description",key:"description"}
			],
		}
	},
	watch: {
		revenueCodes() {
			if (this.revenueCodes)
				this.localCodes = this.revenueCodes
		}
	},
	methods: {
		modelChange() {
			this.$emit('modelChange')
			this.fetchCodes()
		},
		addRevenueCode() {
			let vm = this

			let payload = {
				code: this.code,
				description: this.codeDescription
			}

			this.postData("RevenueCode/save",payload,true).then(response => {
				if (response.success) {
					vm.$emit("modelChange")

					vm.code = ""
					vm.codeDescription = ""

					vm.fetchCodes()
				}
			})
		},
		fetchCodes() {
			let vm = this

			this.getJSON("RevenueCode/get").then(response => {
				vm.localCodes = response.data
			})
		}
	},
	created() {
		if (!this.revenueCodes)
			this.fetchCodes()
		else
			this.localCodes = this.revenueCodes
	}
}
</script>

